import carousel from './carousel';

const iconSwiper = document.getElementById('IconSection-swiper');
const breakpoint = window.matchMedia('(min-width: 1024px)');

let swiper;

export default function breakpointChecker() {
  if (breakpoint.matches === true) {
    if (swiper) swiper.destroy(true, true);
  } else if (breakpoint.matches === false) {
    swiper = carousel(iconSwiper, {
      loop: false,
      spaceBetween: 40,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
          slidesPerGroup: 2,
          centeredSlides: false,
          centeredSlidesBounds: true,
        },
        1024: {
          enabled: false,
        },
      },
    });
  }
}

breakpoint.addEventListener('change', breakpointChecker);

breakpointChecker();
